import React, { useEffect, useRef, useState } from 'react';
import { Section, SectionPill } from './Shared';
import { pillars } from '../data/landing';

/** Only starts downloading the video when it's about to scroll into view. */
const LazyVideo = ({
  src
}: {
  src: string;
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [load, setLoad] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setLoad(true);
        observer.disconnect();
      }
    }, {
      rootMargin: '300px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className="mx-auto w-full max-w-[340px] md:max-w-[380px] rounded-3xl overflow-hidden border border-brand-gold/40 shadow-[0_10px_30px_rgba(23,61,31,0.2)] bg-brand-purpleDark aspect-[9/16]" data-id="element-143" data-mp="1t8rnpq0qzdii">
      {load && <video src={src} className="w-full h-full object-cover" autoPlay muted loop playsInline controls preload="metadata" data-id="element-144" data-mp="1kaxq8br8ydtr" />}
    </div>;
};
export const MaterialPreview = () => <Section className="max-w-5xl" data-id="element-145" data-mp="2q72zho2jsb2l">
    <div className="text-center mb-8 md:mb-12" data-id="element-146" data-mp="2q6087f1bc6m5">
      <SectionPill data-id="element-147" data-mp="2lachgv76n5ej">📖 CONOCE EL MATERIAL POR DENTRO</SectionPill>
      <h2 className="text-3xl md:text-5xl font-display font-bold leading-tight text-brand-purpleDark" data-id="element-148" data-mp="1xjoy9drtgtco">
        Consulta. Prepara. Registra.
      </h2>
    </div>

    <LazyVideo src="https://cdn.magicpatterns.com/uploads/aXXPHHKW3BPH1mzduAMmHT/video_para_landing_MAGIC_optimizado.mp4" data-id="element-149" data-mp="1tjy9ffluonas" />

    <div className="mt-12 grid md:grid-cols-3 gap-8 md:gap-0 md:divide-x divide-brand-purple/15" data-id="element-150" data-mp="27bcvxweyv6ml">
      {pillars.map(p => <div key={p.title} className="text-center md:px-8" data-id="element-151" data-mp="1espa2es5bnkg">
          <div className="text-3xl mb-3" aria-hidden="true" data-id="element-152" data-mp="1er4kl3kouutg">
            {p.emoji}
          </div>
          <h3 className="font-serif font-bold text-lg text-brand-purpleDark" data-id="element-153" data-mp="19s1kzynh9gsv">
            {p.title}
          </h3>
          <p className="text-sm md:text-base text-brand-text/80 mt-2 leading-relaxed" data-id="element-154" data-mp="3evgqtszddmpk">
            {p.text}
          </p>
        </div>)}
    </div>
  </Section>;